import React from 'react';
import { Link as LinkScroll } from 'react-scroll'

const TermsNav = () => {
    return (
        <div className='p-2 md:mt-3'>
            <div className="md:shadow-xl rounded-md bg-white ">
                <LinkScroll to="TERMSANDCONDITIONS" offset={-100}  spy={true} smooth={true}>
                    <button className='w-full py-2 shadow hover:bg-bnd-1 hover:text-white font-poppins focus:outline-none'>TERMS AND CONDITIONS</button>
                </LinkScroll>
                <LinkScroll to="DELIVERYANDRISKINVOLVED" offset={-100}  spy={true} smooth={true}>
                    <button className='w-full py-2 shadow hover:bg-bnd-1 hover:text-white font-poppins focus:outline-none'>DELIVERY AND RISK INVOLVED</button>
                </LinkScroll>
                <LinkScroll to="CANCELLATIONSANDRETURNS" offset={-100}  spy={true} smooth={true}>
                    <button className='w-full py-2 shadow hover:bg-bnd-1 hover:text-white font-poppins focus:outline-none'>CANCELLATIONS AND RETURNS</button>
                </LinkScroll>
                <LinkScroll to="DetailedTerms" offset={-100}  spy={true} smooth={true}>
                    <button className='w-full py-2 shadow hover:bg-bnd-1 hover:text-white font-poppins focus:outline-none'>Detailed Terms ..</button>
                </LinkScroll>
                <LinkScroll to="FOREWORD" offset={-100}  spy={true} smooth={true}>
                    <button className='w-full py-2 shadow hover:bg-bnd-1 hover:text-white font-poppins focus:outline-none'>FOREWORD</button>
                </LinkScroll>
                <LinkScroll to="THISWEBSITE" offset={-100}  spy={true} smooth={true}>
                    <button className='w-full py-2 shadow hover:bg-bnd-1 hover:text-white font-poppins focus:outline-none'>THIS WEBSITE</button>
                </LinkScroll>
                <LinkScroll to="TheService" offset={-100}  spy={true} smooth={true}>
                    <button className='w-full py-2 shadow hover:bg-bnd-1 hover:text-white font-poppins focus:outline-none'>The Service</button>
                </LinkScroll>
                <LinkScroll to="ONLINEPURCHASE" offset={-100}  spy={true} smooth={true}>
                    <button className='w-full py-2 shadow hover:bg-bnd-1 hover:text-white font-poppins focus:outline-none'>ONLINE PURCHASE</button>
                </LinkScroll>
                <LinkScroll to="Coupon&Price" offset={-100}  spy={true} smooth={true}>
                    <button className='w-full py-2 shadow hover:bg-bnd-1 hover:text-white font-poppins focus:outline-none'>Coupon & Price</button>
                </LinkScroll>
                <LinkScroll to="Summary" offset={-100} spy={true} smooth={true}>
                    <button className='w-full py-2 shadow hover:bg-bnd-1 hover:text-white font-poppins focus:outline-none'>Summary</button>
                </LinkScroll>
            </div>
        </div>
    );
};

export default TermsNav;